export const LIST_LOANS = 'loan.LIST_LOANS'
export const SET_LOANS = 'loan.SET_LOANS'
export const LIST_CLOSED_LOANS = 'loan.LIST_CLOSED_LOANS'
export const SET_CLOSED_LOANS = 'loan.SET_CLOSED_LOANS'
export const REFUND_LOAN = 'loan.REFUND_LOAN'
export const GET_TERM_DATA = 'loan.GET_TERM_DATA'
export const SET_TERM_DATA = 'loan.SET_TERM_DATA'
export const GET_ACTIVE_TERMS = 'loan.GET_ACTIVE_TERMS'
export const SET_ACTIVE_TERMS = 'loan.SET_ACTIVE_TERMS'

export const listLoans = (params, callback) => ({
  type: LIST_LOANS,
  params,
  callback,
})

export const setLoans = (data) => ({
  type: SET_LOANS,
  data,
})

export const listClosedLoans = (params, callback) => ({
  type: LIST_CLOSED_LOANS,
  params,
  callback,
})

export const setClosedLoans = (data) => ({
  type: SET_CLOSED_LOANS,
  data,
})

export const refundLoan = (params, callback) => ({
  type: REFUND_LOAN,
  params,
  callback,
})

export const getTermData = (params, callback) => ({
  type: GET_TERM_DATA,
  params,
  callback,
})

export const setTermData = (data) => ({
  type: SET_TERM_DATA,
  data,
})

export const getActiveTerms = (params, callback) => ({
  type: GET_ACTIVE_TERMS,
  params,
  callback,
})

export const setActiveTerms = (data) => ({
  type: SET_ACTIVE_TERMS,
  data,
})
